<template>
  <div class="dragVerify">
    <div id="captcha"></div>
  </div>
</template>

<script>
import { createImageAuthCode, checkoutImageAuthCode } from "@/api/accountManage";
//全局vuex
import { mapGetters } from 'vuex';
import DragVerify from "./index";
export default {
  name: "dragVerify",
  props: {
    business: {
      type: [Number, String]
    }
  },
  data() {
    return {
      DragVerify: null,
      ycoord: 0,
      imgUrl: null, // 验证的图片地址
      captchaKey: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(['business', 'captchaType'])
  },
  methods: {
    //获取拼图位置
    async init() {
      document.getElementById("captcha").innerHTML = "";
      const paramsData = {
        business: this.business,
        lowerX: 73,
        upperX: 247,
        lowerY: 28,
        upperY: 121
      };
      const res = await createImageAuthCode(paramsData);
      const { coordsX, coordsY, imageUrl, captchaKey } = res.data;
      this.ycoord = coordsY;
      //初始化拼图验证
      this.DragVerify = new DragVerify({
        el: document.getElementById("captcha"),
        onSuccess: this.onSuccess,
        onFail: this.onFail,
        onRefresh: this.onRefresh,
        x: coordsX,
        y: coordsY,
        img: imageUrl
      });
      this.captchaKey = captchaKey
      this.imgUrl = imageUrl
      this.DragVerify.init();
    },
    // 前端验证成功后
    async onSuccess(x) {
      const paramsData = {
        type: this.captchaType,
        business: this.business,
        coordsX: x,
        imageUrl: this.imgUrl,
        coordsY: this.ycoord,
        captchaKey: this.captchaKey
      };
      let { data } = await checkoutImageAuthCode(paramsData);
      this.$emit("verifySuccess", data);
    },
    //验证失败
    onFail(left) {
      console.log(left);
    },
    //刷新
    onRefresh() {
      this.init();
    }
  }
};
</script>

<style lang="scss">
.dragVerify {
  background: #fff;
  display: inline-block;
  padding: 20px;
  border-radius: 4px;
  #captcha {
    min-height: 257px;
  }
  .canvas {
    border-radius: 4px;
  }
  .block {
    position: absolute;
    left: 0;
    top: 0;
  }
  .sliderContainer {
    position: relative;
    text-align: center;
    width: 320px;
    height: 46px;
    line-height: 46px;
    margin-top: 14px;
    background: #e9ebf1;
    font-size: 16px;
    font-weight: 500;
    color: #9da1ac;
    padding-left: 46px;
  }

  .sliderContainer_active .slider {
    height: 46px;
  }

  .sliderContainer_active .sliderMask {
    height: 46px;
  }

  .sliderContainer_success .slider {
    height: 46px;
    background-color: #52ccba !important;
  }

  .sliderContainer_success .sliderMask {
    height: 46px;
    background-color: #d2f4ef;
  }

  .sliderContainer_success .sliderIcon {
    background-position: 0 0 !important;
  }

  .sliderContainer_fail .slider {
    height: 46px;
    background-color: #f57a7a !important;
  }

  .sliderContainer_fail .sliderMask {
    height: 46px;
    background-color: #fce1e1;
  }

  .sliderContainer_fail .sliderIcon {
    top: 14px;
    background-position: 0 -82px !important;
  }

  .sliderContainer_active .sliderText,
  .sliderContainer_success .sliderText,
  .sliderContainer_fail .sliderText {
    display: none;
  }

  .sliderMask {
    position: absolute;
    left: 0;
    top: 0;
    height: 46px;
    background: #d1e9fe;
  }

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 46px;
    height: 46px;
    cursor: pointer;
    transition: background 0.2s linear;
    width: 46px;
    height: 46px;
    background: #2858f8;
    border-radius: 4px;
  }

  .slider:hover {
    background: #1991fa;
  }

  .icon-a-wangyou2x {
    font-size: 18px;
    color: #fff;
  }

  .icon-a-shuaxin2x {
    position: absolute;
    font-size: 24px;
    right: 25px;
    top: -46px;
    color: #909399;
    cursor: pointer;
    &:hover {
      color: #2858f8;
    }
  }
}
</style>
